// LOGIN TO POWER AMR
export const POWERAMR_LOGIN_LOADING = "POWERAMR_LOGIN_LOADING";
export const POWERAMR_LOGIN_SUCCESS = "POWERAMR_LOGIN_SUCCESS";
export const POWERAMR_LOGIN_FAILURE = "POWERAMR_LOGIN_FAILURE";
export const POWERAMR_LOGIN_RESET = "POWERAMR_LOGIN_RESET";

// GET DEVICE LIST
export const GET_DEVICE_LIST_LOADING = "GET_DEVICE_LIST_LOADING";
export const GET_DEVICE_LIST_SUCCESS = "GET_DEVICE_LIST_SUCCESS";
export const GET_DEVICE_LIST_FAILURE = "GET_DEVICE_LIST_FAILURE";
export const GET_DEVICE_LIST_RESET = "GET_DEVICE_LIST_RESET";

// GET INVERTER LOG DATA
export const GET_INVERTER_LOG_DATA_LOADING = "GET_INVERTER_LOG_DATA_LOADING";
export const GET_INVERTER_LOG_DATA_SUCCESS = "GET_INVERTER_LOG_DATA_SUCCESS";
export const GET_INVERTER_LOG_DATA_FAILURE = "GET_INVERTER_LOG_DATA_FAILURE";
export const GET_INVERTER_LOG_DATA_RESET = "GET_INVERTER_LOG_DATA_RESET";

// GET INVERTER LOG DATA
export const GET_INVERTER_STRING_DATA_LOADING =
  "GET_INVERTER_STRING_DATA_LOADING";
export const GET_INVERTER_STRING_DATA_SUCCESS =
  "GET_INVERTER_STRING_DATA_SUCCESS";
export const GET_INVERTER_STRING_DATA_FAILURE =
  "GET_INVERTER_STRING_DATA_FAILURE";
export const GET_INVERTER_STRING_DATA_RESET = "GET_INVERTER_STRING_DATA_RESET";

// GET PLANT STATUS
export const GET_PLANT_STATUS_LOADING = "GET_PLANT_STATUS_LOADING";
export const GET_PLANT_STATUS_SUCCESS = "GET_PLANT_STATUS_SUCCESS";
export const GET_PLANT_STATUS_FAILURE = "GET_PLANT_STATUS_FAILURE";
export const GET_PLANT_STATUS_RESET = "GET_PLANT_STATUS_RESET";

// GET PLANT STATUS
export const GET_DASHBOARD_STATS_LOADING = "GET_DASHBOARD_STATS_LOADING";
export const GET_DASHBOARD_STATS_SUCCESS = "GET_DASHBOARD_STATS_SUCCESS";
export const GET_DASHBOARD_STATS_FAILURE = "GET_DASHBOARD_STATS_FAILURE";
export const GET_DASHBOARD_STATS_RESET = "GET_DASHBOARD_STATS_RESET";

// GET ALARM EVENTS
export const GET_ALARM_EVENTS_LOADING = "GET_ALARM_EVENTS_LOADING";
export const GET_ALARM_EVENTS_SUCCESS = "GET_ALARM_EVENTS_SUCCESS";
export const GET_ALARM_EVENTS_FAILURE = "GET_ALARM_EVENTS_FAILURE";
export const GET_ALARM_EVENTS_RESET = "GET_ALARM_EVENTS_RESET";

// GET MONTH GENERATION
export const GET_MONTH_GENERATION_LOADING = "GET_MONTH_GENERATION_LOADING";
export const GET_MONTH_GENERATION_SUCCESS = "GET_MONTH_GENERATION_SUCCESS";
export const GET_MONTH_GENERATION_FAILURE = "GET_MONTH_GENERATION_FAILURE";
export const GET_MONTH_GENERATION_RESET = "GET_MONTH_GENERATION_RESET";

// GET GENERATION GRAPH
export const GET_GENERATION_GRAPH_LOADING = "GET_GENERATION_GRAPH_LOADING";
export const GET_GENERATION_GRAPH_SUCCESS = "GET_GENERATION_GRAPH_SUCCESS";
export const GET_GENERATION_GRAPH_FAILURE = "GET_GENERATION_GRAPH_FAILURE";
export const GET_GENERATION_GRAPH_RESET = "GET_GENERATION_GRAPH_RESET";

// GET INVERTER GRAPH DATA
export const GET_INVERTER_GRAPH_DATA_LOADING =
  "GET_INVERTER_GRAPH_DATA_LOADING";
export const GET_INVERTER_GRAPH_DATA_SUCCESS =
  "GET_INVERTER_GRAPH_DATA_SUCCESS";
export const GET_INVERTER_GRAPH_DATA_FAILURE =
  "GET_INVERTER_GRAPH_DATA_FAILURE";
export const GET_INVERTER_GRAPH_DATA_RESET = "GET_INVERTER_GRAPH_DATA_RESET";

// GET METRIC TRENDS
export const GET_METRIC_TRENDS_LOADING = "GET_METRIC_TRENDS_LOADING";
export const GET_METRIC_TRENDS_SUCCESS = "GET_METRIC_TRENDS_SUCCESS";
export const GET_METRIC_TRENDS_FAILURE = "GET_METRIC_TRENDS_FAILURE";
export const GET_METRIC_TRENDS_RESET = "GET_METRIC_TRENDS_RESET";
